import PropTypes from 'prop-types';
import styles from './Button.module.scss';
export const BUTTON_VARIANTS = ['default', 'primary', 'secondary', 'error', 'warning', 'success', 'info', 'transparent'];

const Button = ({ children, variant, className, href, ...props }) => {
    return (
        href
            ? <a className={['govuk-button', styles[variant], className].join(' ')} href={href} {...props}>
                {children}
            </a>
            : <button className={['govuk-button', styles[variant], className].join(' ')} {...props}>
                {children}
            </button>
    );
};

Button.propTypes = {
    children: PropTypes.any,
    variant: PropTypes.oneOf(BUTTON_VARIANTS),
    className: PropTypes.string,
    href: PropTypes.string
};

Button.defaultProps = {
    variant: 'primary'
};

export default Button;
